import React, { useEffect, useState } from 'react';
import Modal from '../ModalConversion';
import { GeneralChannelForm } from './GeneralChannelForm';
import { ValidationChannelForm } from './ValidationChannelForm';
import { ReportsChannelForm } from './ReportsChannelForm';
import { ConnectionChannelForm } from './ConnectionChannelForm';

const TABS = [
    { value: 'general', label: 'Datos generales' },
    { value: 'validacion', label: 'Configuración validación' },
    { value: 'reportes', label: 'Reportes de estados' },
    { value: 'conexion', label: 'Conexión' },
];

export function ChannelModal({ isOpen, onClose, channel, isNew, onSave, saving }) {
    const [activeTab, setActiveTab] = useState('general');
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setActiveTab('general');
            setError('');
        }
    }, [isOpen, isNew, channel]);

    if (!isOpen) return null;

    const handleGeneralSave = async (payload) => {
        setError('');
        const result = await onSave(payload);
        if (result && result.ok === false) {
            setError(result.msg || 'No se pudo guardar el canal');
        }
        return result;
    };

    const handleSectionSave = (sectionPayload) => {
        return handleGeneralSave({ _id: channel._id, ...sectionPayload });
    };

    const pendingLabel = activeTab === 'validacion'
        ? 'configuración de validación'
        : activeTab === 'conexion'
            ? 'información de conexión'
            : 'reportes de estados';

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <div className="p-4">
                <h4 className="text-white mb-3">{isNew ? 'Nuevo canal' : `Editar canal: ${channel.name || channel.alias || ''}`}</h4>

                {error && <div className="alert alert-danger py-2">{error}</div>}

                <nav className="products mb-4">
                    <ul>
                        {TABS.map((tab) => (
                            <li
                                key={tab.value}
                                className={activeTab === tab.value ? 'selected' : ''}
                                onClick={() => {
                                    setActiveTab(tab.value);
                                    setError('');
                                }}
                            >
                                {tab.label}
                            </li>
                        ))}
                    </ul>
                </nav>

                {isNew ? (
                    activeTab === 'general' ? (
                        <GeneralChannelForm
                            isNew
                            isComplete={false}
                            onSubmit={handleGeneralSave}
                            saving={saving}
                            onCancel={onClose}
                        />
                    ) : (
                        <div className="alert alert-info py-2">
                            Crea primero el canal en la pestaña <strong>Datos generales</strong> para poder configurar la {pendingLabel.toLowerCase()}.
                        </div>
                    )
                ) : (
                    <>
                        {activeTab === 'general' && (
                            <GeneralChannelForm
                                isNew={false}
                                isComplete={!!channel.is_complete}
                                initial={channel}
                                onSubmit={handleSectionSave}
                                saving={saving}
                                onCancel={onClose}
                            />
                        )}
                        {activeTab === 'validacion' && (
                            <ValidationChannelForm
                                initial={channel}
                                content={channel.content || []}
                                onSubmit={handleSectionSave}
                                saving={saving}
                                onCancel={onClose}
                            />
                        )}
                        {activeTab === 'reportes' && (
                            <ReportsChannelForm
                                initial={channel}
                                onSubmit={handleSectionSave}
                                saving={saving}
                                onCancel={onClose}
                            />
                        )}
                        {activeTab === 'conexion' && (
                            <ConnectionChannelForm
                                initial={channel}
                                onSubmit={handleSectionSave}
                                saving={saving}
                                onCancel={onClose}
                            />
                        )}
                    </>
                )}
            </div>
        </Modal>
    );
}

export default ChannelModal;